export default __webpack_public_path__ + "static/media/Benefits@2x.d0fecd28.svg";